import React, { useEffect, useRef, useState } from 'react';
import ReactMarkdown from 'react-markdown';

import { useGraphQLChat } from './useGraphQLChat';

const ChatWidget: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [input, setInput] = useState('');
  const chatRef = useRef<HTMLDivElement | null>(null);

  const { messages, sendMessage, loading } = useGraphQLChat();

  const handleSend = () => {
    if (input.trim()) {
      sendMessage(input);
      setInput('');
    }
  };

  // Auto-scroll to bottom
  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Toggle Button */}
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="w-14 h-14 rounded-full bg-black text-white shadow-lg flex items-center justify-center text-2xl hover:bg-gray-800"
        >
          💬
        </button>
      )}

      {/* Chat Window */}
      {isOpen && (
        <div className="w-96 h-[500px] flex flex-col bg-white border border-gray-300 shadow-xl rounded-lg overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between px-4 py-3 bg-black text-white">
            <span className="font-semibold">Chat</span>
            <button
              onClick={() => setIsOpen(false)}
              className="text-white hover:text-gray-300 text-lg"
            >
              ×
            </button>
          </div>

          {/* Messages */}
          <div ref={chatRef} className="flex-1 overflow-y-auto px-3 py-2 flex flex-col gap-2">
            {messages.map((m, idx) => (
              <div
                key={idx}
                className={`max-w-[85%] whitespace-pre-wrap p-2 rounded-lg text-sm ${
                  m.sender === 'user'
                    ? 'bg-black text-white self-end text-right'
                    : 'bg-gray-100 text-black self-start text-left'
                }`}
              >
                <ReactMarkdown>{m.message}</ReactMarkdown>
              </div>
            ))}
            {loading && <div className="italic text-gray-500 text-xs">Assistant is typing...</div>}
          </div>

          {/* Input */}
          <div className="flex px-3 py-2 border-t border-gray-300">
            <input
              className="flex-1 border border-gray-300 rounded px-2 py-1 text-sm"
              placeholder="Type a message..."
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleSend()}
            />
            <button
              onClick={handleSend}
              disabled={loading}
              className="ml-2 bg-black text-white px-3 py-1 rounded text-sm hover:bg-gray-800"
            >
              {loading ? '...' : 'Send'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatWidget;
